module.exports = __webpack_public_path__ + "img/sample-logo5.fb55a45a.png";